import { Item } from '../../../../../../components/multi-select/multi-select-list-filters';
import { MultiSelectListFilters } from '../../../../../../components/multi-select/multi-select-list-filters';
import Utils from '../../../../../../utils/immersive_utils';
import './styles.scss';

type PortfolioRiskSettingsItemProps = {
  itemTitle: string;
  items: Item[];
  selectedItems: Item[];
  handleChange: (item: Item[]) => void;
  classNames?: string;
};

export const PortfolioRiskSettingsItem = ({
  itemTitle,
  items,
  selectedItems,
  handleChange,
  classNames,
}: PortfolioRiskSettingsItemProps) => {
  return (
    <div className="portfolio-risk-settings-item">
      <div className="portfolio-risk-settings-header">
        <span>{itemTitle}</span>
      </div>
      <div className="portfolio-risk-settings-content">
        <MultiSelectListFilters
          items={items.map((item) => ({ ...item, label: Utils.truncateLabel(item.label, 19) }))}
          selectedItems={selectedItems}
          setSelectedItems={handleChange}
          classNames={`${classNames ? classNames : 'portfolio-risk-settings-content-multi-select'}`}
        />
      </div>
    </div>
  );
};
